/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  Checkbox,
  CheckboxList,
  FilterablePicker,
  FormField,
  MarketSelector,
  Text,
  Alert,
  ExportModal,
  RadioGroup,
  RadioItem,
} from '../uiold';
import { themeColors } from '../uiold/Constants';
import DataStore from '../../support/DataStore';
import DownloadTarget from '../../support/DownloadTarget';
import mapToPlainObject from '../../support/mapToPlainObject';
import FormSection from './FormSection';
import {
  DEFAULT_FORMS,
  DEFAULT_SIGNUP_FORM_ID,
} from '../../support/shared/constants/Constants';
import { APP_STATUSES } from '../../support/constants/AppStatuses';

import IndexedList from '../../support/shared/IndexedList';
import SignupFormModel from '../FormBuilder/SignupFormModel';
import { Market } from '../../types/shared/Market';
import { Account } from '../../types/shared/Account';
import { AppStatus } from '../../core/constants/AppStatus';
import { getCategoryOptionsFromFields } from '../../support/helpers/CategoryOptions';

const EXPORT_MARKET_DATES = {
  exportAll: t('Export all market dates'),
  exportSelected: t('Export specific market dates'),
};

let dataStore = DataStore.getInstance('app');

type OptionsContent = string | { fieldID: string; name: string };
type Tag = {
  id: string;
  name: string;
  color: string;
};

type ExportMarketDatesChoice = keyof typeof EXPORT_MARKET_DATES;

type Props = {
  isOpen?: boolean;
  tags: Array<Tag>;
  account: Account;
  onHide: () => void;
  formDef: SignupFormModel;
  markets: IndexedList<Market>;
};

type State = {
  isWorking: boolean;
  isTotalPriceSelected: boolean;
  isInternalNotesSelected: boolean;
  isSignupDateSelected: boolean;
  isStatusSelected: boolean;
  isTagSelected: boolean;
  filterText: string;
  statusesSelected: Set<string>;
  fieldsSelected: Set<string>;
  exportMarketDates: ExportMarketDatesChoice;
  selectedMarketDates: Map<string, Set<string>>;
  categoriesSelected: Set<string>;
  tagsSelected: Set<string>;
  error: Error | null | undefined;
};

class VendorExportDialog extends Component<Props, State> {
  state: State = {
    isWorking: false,
    isTotalPriceSelected: false,
    isInternalNotesSelected: false,
    isSignupDateSelected: false,
    isStatusSelected: true,
    isTagSelected: false,
    filterText: '',
    statusesSelected: getInitialStatuses(),
    fieldsSelected: getFieldsSelected(),
    exportMarketDates: 'exportAll',
    selectedMarketDates: new Map<string, Set<string>>(),
    categoriesSelected: new Set(getCategories(this.props.formDef)),
    tagsSelected: new Set<string>(),
    error: null,
  };

  render() {
    let { isOpen, formDef, markets } = this.props;
    let { isWorking } = this.state;
    let isLoading = formDef == null || isWorking;

    return (
      <ExportModal
        isOpen={isOpen ?? true}
        title={t('Export Vendors')}
        isLoading={isLoading}
        onSubmit={this._onSubmit}
        onClose={this._onHide}
      >
        <>
          {this._renderError()}
          {!!markets && this._renderMarketDatesFormField()}
          <FormSection
            title={t('Include Statuses')}
            subtitle={t('Exports vendors with selected status(es)')}
          >
            {this._renderStatusCheckboxes()}
          </FormSection>
          <FormSection
            zIndex={5}
            title={t('Categories')}
            subtitle={t('Exports only vendors with selected categories')}
          >
            {this._renderCategoriesSection()}
          </FormSection>
          <FormSection
            zIndex={4}
            title={t('Tags')}
            subtitle={t('Exports vendors with selected tags')}
          >
            {this._renderTagsCheckboxes()}
          </FormSection>
          <FormSection
            zIndex={3}
            title={t('Form Fields')}
            subtitle={t('Exports selected Form Fields as column(s)')}
          >
            {this._renderFormFieldsCheckboxes(formDef)}
          </FormSection>
          {this._renderAdditionalColumns()}
        </>
      </ExportModal>
    );
  }

  _renderAdditionalColumns = () => {
    return (
      <FormField
        render={() => (
          <FormSection
            noBorderBottom
            title={t('Additional Columns')}
            subtitle={t('Shows these items as additional column(s)')}
          >
            <Checkbox
              isChecked={this.state.isTotalPriceSelected}
              onChange={() =>
                this._updateAdditionalColumn('isTotalPriceSelected')
              }
              text={t('Total Price')}
            />
            <Checkbox
              isChecked={this.state.isInternalNotesSelected}
              onChange={() =>
                this._updateAdditionalColumn('isInternalNotesSelected')
              }
              text={t('Internal Notes')}
            />
            <Checkbox
              isChecked={this.state.isSignupDateSelected}
              onChange={() =>
                this._updateAdditionalColumn('isSignupDateSelected')
              }
              text={t('Signup Date')}
            />
            <Checkbox
              isChecked={this.state.isStatusSelected}
              onChange={() => this._updateAdditionalColumn('isStatusSelected')}
              text={t('Status')}
            />
            <Checkbox
              isChecked={this.state.isTagSelected}
              onChange={() => this._updateAdditionalColumn('isTagSelected')}
              text={t('Tags')}
            />
          </FormSection>
        )}
      />
    );
  };

  _renderStatusCheckboxes = () => {
    let { statusesSelected } = this.state;
    return (
      <CheckboxList showSelectAll onSelectionChange={this._toggleStatus}>
        {APP_STATUSES.map((status) => (
          <Checkbox
            key={status}
            isChecked={statusesSelected.has(status)}
            text={status}
          />
        ))}
      </CheckboxList>
    );
  };

  _renderFormFieldsCheckboxes = (formDef: SignupFormModel) => {
    let fields = formDef.fields.filter((field) =>
      isExportable(field.definition),
    );

    let optionArray: Array<OptionsContent> = fields.mapToArray((field) => {
      let { definition } = field;
      let fieldID = field.id;
      let name = typeof definition.name === 'string' ? definition.name : '';
      return { fieldID, name };
    });

    return (
      <FilterablePicker
        options={optionArray}
        filterText={this.state.filterText}
        selectedItem={this.state.fieldsSelected}
        onFilterTextChange={(text) => {
          this.setState({
            filterText: text,
          });
        }}
        onSelectAll={() => {
          this._selectAll('fieldsSelected');
        }}
        onChange={(selection) => {
          this._updateColumnString('fieldsSelected', selection);
        }}
      />
    );
  };

  _renderTagsCheckboxes = () => {
    let { tags } = this.props;
    if (tags == null || tags.length === 0) {
      // TODO: I know this should return react element
      // currently I just return text, should return something better
      return <Text style={styles.paneHeader}>{t('No tags')}</Text>;
    }

    let optionArray: Array<OptionsContent> = tags.map((item) => {
      return { fieldID: item.id, name: item.name };
    });

    return (
      <FilterablePicker
        options={optionArray}
        filterText={this.state.filterText}
        selectedItem={this.state.tagsSelected}
        onFilterTextChange={(text) => {
          this.setState({
            filterText: text,
          });
        }}
        onSelectAll={() => {
          this._selectAll('tagsSelected');
          this.setState((prevState) => ({
            isTagSelected: !prevState.isTagSelected,
          }));
        }}
        onChange={(selection) => {
          this._updateColumnString('tagsSelected', selection);
        }}
      />
    );
  };

  _renderCategoriesSection = () => {
    let categories = getCategories(this.props.formDef);
    return (
      <FilterablePicker
        options={categories}
        filterText={this.state.filterText}
        selectedItem={this.state.categoriesSelected}
        onFilterTextChange={(text) => {
          this.setState({
            filterText: text,
          });
        }}
        onSelectAll={() => {
          this._selectAll('categoriesSelected');
        }}
        onChange={(selection) => {
          this._updateColumnString('categoriesSelected', selection);
        }}
      />
    );
  };

  _renderMarketDatesFormField = () => {
    let { exportMarketDates } = this.state;
    return (
      <View style={styles.formSection}>
        <Text style={styles.paneHeader}>{t('Markets and Dates')}</Text>
        <RadioGroup
          onChange={(value) =>
            this.setState({
              exportMarketDates: value as ExportMarketDatesChoice,
            })
          }
          selectedValue={exportMarketDates}
          style={styles.rowFlexed}
        >
          {Object.entries(EXPORT_MARKET_DATES).map(([choice, title]) => {
            return (
              <RadioItem
                key={choice}
                title={title}
                value={choice}
                style={styles.radioItem}
              />
            );
          })}
        </RadioGroup>
        {exportMarketDates === 'exportSelected'
          ? this._renderMarketDatesCheckboxes()
          : null}
      </View>
    );
  };

  _renderMarketDatesCheckboxes = (): React.ReactNode => {
    let { selectedMarketDates } = this.state;
    let { markets } = this.props;

    if (!markets) {
      return <Text>{t('No markets')}</Text>;
    }
    let filteredMarkets = markets.filter((market) => market.dates.length !== 0);
    return filteredMarkets.mapToArray((market) => (
      <MarketSelector
        key={market.id}
        marketTitle={market.name}
        dates={market.dates}
        selectedItems={selectedMarketDates.get(market.id) || new Set()}
        onSelectAll={() => {
          this._selectAllMarketDates(market.id);
        }}
        onChange={(selectedKey: string) =>
          this._updateColumnMarketDates(market.id, selectedKey)
        }
      />
    ));
  };

  _renderFieldChooser = (): React.ReactNode => {
    let { formDef } = this.props;
    let { fieldsSelected } = this.state;
    let fields = formDef.fields.filter((field) =>
      isExportable(field.definition),
    );

    return fields.mapToArray((field) => {
      let { definition } = field;
      let name = typeof definition.name === 'string' ? definition.name : '';
      return (
        <Checkbox
          key={field.id}
          isChecked={fieldsSelected.has(field.id)}
          text={name}
        />
      );
    });
  };

  _renderError = () => {
    if (!this.state.error) {
      return;
    }
    return (
      <Alert
        type="error"
        onDismiss={this._errorDismiss}
        text={this.state.error.message}
        style={styles.errorAlertSection}
      />
    );
  };

  _toggleStatus = (statusesSelected: Set<string>) => {
    this.setState({
      isStatusSelected: statusesSelected.size > 0,
      statusesSelected,
    });
  };

  // TODO: The combination of _selectAll() and _selectGetter() is pretty
  // convoluted; simplify this.
  _selectAll = (columnName: string) => {
    let oldSet: any = this.state[columnName as keyof State];
    let newSet =
      oldSet.size > 0 ? new Set() : new Set(this._selectGetter(columnName));
    this.setState({ [columnName]: newSet } as any);
  };

  _selectGetter = (columnName: string) => {
    switch (columnName) {
      case 'statusesSelected': {
        return getInitialStatuses();
      }
      case 'categoriesSelected': {
        let categories = getCategories(this.props.formDef);
        let result: Set<string> = new Set(categories);
        return result;
      }
      case 'fieldsSelected': {
        return getAllFields(this.props.formDef);
      }
      case 'tagsSelected': {
        return new Set(this.props.tags.map((tag) => tag.id));
      }
      default: {
        return new Set() as Set<string>;
      }
    }
  };

  _updateColumnString = (columnName: string, selection: string) => {
    let oldSet: any = this.state[columnName as keyof State];
    let newSet = new Set(oldSet);
    newSet.has(selection) ? newSet.delete(selection) : newSet.add(selection);
    this.setState({ [columnName]: newSet } as any);
    switch (columnName) {
      case 'tagsSelected': {
        if (newSet.size > 0) {
          this.setState({ isTagSelected: true });
        } else {
          this.setState({ isTagSelected: false });
        }
        return 'tagsSelected';
      }
      default: {
        return columnName;
      }
    }
  };

  _updateColumn = (columnName: string, selectedKeys: Set<string>) => {
    this.setState({ [columnName]: selectedKeys } as any);
  };

  _updateAdditionalColumn = (columnName: string) => {
    this.setState({
      [columnName]: !this.state[columnName as keyof State],
    } as any);
  };

  _updateColumnMarketDates = (marketID: string, selection: string) => {
    let { selectedMarketDates } = this.state;
    let newSet = new Set(selectedMarketDates.get(marketID));
    newSet.has(selection) ? newSet.delete(selection) : newSet.add(selection);
    let newMap = new Map(selectedMarketDates);
    newMap.set(marketID, newSet);
    this.setState({ selectedMarketDates: newMap });
  };

  _selectAllMarketDates = (marketID: string) => {
    let allMarketDates = getAllMarketDates(this.props.markets);
    let { selectedMarketDates } = this.state;
    let oldSet = selectedMarketDates.get(marketID) || new Set();
    let newSet =
      oldSet.size > 0
        ? new Set<string>()
        : new Set(allMarketDates.get(marketID));
    let newMap = new Map(selectedMarketDates);
    newMap.set(marketID, newSet);
    this.setState({ selectedMarketDates: newMap });
  };

  _onSubmit = () => {
    const { account, formDef } = this.props;
    let {
      statusesSelected,
      fieldsSelected,
      exportMarketDates,
      selectedMarketDates,
      categoriesSelected,
      tagsSelected,
      isTotalPriceSelected,
      isInternalNotesSelected,
      isSignupDateSelected,
      isStatusSelected,
      isTagSelected,
    } = this.state;
    this.setState({ error: null });
    let season = dataStore.get('season');
    // TODO: Handle the case where the user has manually selected all dates?
    let includeAllMarketDates = exportMarketDates === 'exportAll';
    let data = {
      statusesSelected: Array.from(statusesSelected),
      fieldsSelected: Array.from(fieldsSelected),
      includeAllMarketDates,
      // Send an empty selection for the "exportAll" case.
      selectedMarketDates: includeAllMarketDates
        ? {}
        : mapToPlainObject(selectedMarketDates, (dates) => Array.from(dates)),
      categoriesSelected: Array.from(categoriesSelected),
      tagsSelected: Array.from(tagsSelected),
      authToken: account.token,
      seasonID: season ? season.id : undefined,
      isTotalPriceSelected,
      isInternalNotesSelected,
      isSignupDateSelected,
      isStatusSelected,
      isTagSelected,
      categoryOptions: getCategoryOptionsFromFields(formDef.fields),
    };
    DownloadTarget.post('/api/vendors/export', data);
    this._onHide();
  };

  _onHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  _errorDismiss = () => {
    this.setState({ error: null });
  };
}

function getAllFields(formDef: SignupFormModel): Set<string> {
  let fieldsSelected = formDef.fields.reduce((set: Set<string>, fieldDef) => {
    if (isExportable(fieldDef.definition)) {
      set.add(fieldDef.definition.id);
    }
    return set;
  }, new Set<string>());
  return fieldsSelected;
}

function getAllMarketDates(markets: IndexedList<Market>) {
  let marketDatesMap = new Map<string, Set<string>>();
  for (let market of markets.toArray()) {
    marketDatesMap.set(market.id, new Set(market.dates));
  }
  return marketDatesMap;
}

function getFieldsSelected(): Set<string> {
  let defaultFormDef = DEFAULT_FORMS[DEFAULT_SIGNUP_FORM_ID];
  let defaultFormFields =
    (DEFAULT_FORMS[DEFAULT_SIGNUP_FORM_ID] && defaultFormDef.fields) || [];
  let fieldsSelected = defaultFormFields.reduce(
    (set: Set<string>, fieldDef) => {
      if (fieldDef.is_required && isExportable(fieldDef)) {
        set.add(fieldDef.id);
      }
      return set;
    },
    new Set<string>(),
  );
  return fieldsSelected;
}

function getInitialStatuses(): Set<string> {
  let statuses = APP_STATUSES.filter((status) => status !== AppStatus.DECLINED);
  return new Set(statuses);
}

function getCategories(formDef: SignupFormModel): Array<string> {
  const categories = getCategoryOptionsFromFields(formDef.fields);
  const categoryNames = categories.map((category) => category.name);
  return categoryNames;
}

function isExportable(fieldDef: any): boolean {
  return (
    // Filter out non-input fields.
    fieldDef.name != null && // Filter out yes/no fields that require a "yes".
    (fieldDef.type !== 'BooleanElement' || !fieldDef.require_acceptance) && // Filter out market dates field (because dates can be included as columns).
    fieldDef.type !== 'MarketSelectorElement'
  );
}

let styles = StyleSheet.create({
  paneHeader: {
    marginBottom: 8,
    fontWeight: '600',
    color: themeColors.darkGrey,
  },
  errorAlertSection: {
    marginHorizontal: 30,
  },
  formSection: {
    paddingHorizontal: 30,
    paddingTop: 10,
    paddingBottom: 20,
    borderBottomWidth: StyleSheet.hairlineWidth * 2,
    borderColor: themeColors.lightGrey,
  },
  radioItem: {
    marginRight: 30,
    marginVertical: 10,
  },
  rowFlexed: {
    flexDirection: 'row',
  },
});

export default VendorExportDialog;
